export default "__VITE_ASSET__ZRkp4pmb__"